import { HTTP } from '@/http'
import moment from 'moment'
// initial state
const state = {
  summaryData: {},
  reportMonths: {},
  preloader: true,
  reportPreloader: true,
  year: new Date().getFullYear(),
  dateFrom: '',
  dateTo: '',
}
// mutations
const mutations = {
  setSummaryData: function(state, sumData) {
    state.summaryData = {...state.summaryData, [sumData.year]:sumData.data}
  },
  setReportMonths: function(state, data) {
    state.reportMonths = data
  },
  setPreloaderState: function(state, value) {
    state.preloader = value
  },
  setReportPreloaderState: function(state, value) {
    state.reportPreloader = value
  },
  setYear: function(state, value) {
    state.year = value
  },
}
// actions
const actions = {
   async updateSummary(context, params) {
    let access = context.rootGetters.chechAccess('summary')
    if (!access) {
      context.commit('setPreloaderState', false)
      return false
    }
    let defaultParams = { year: state.year }
    params = params || defaultParams

    context.commit('setPreloaderState', true)
     await HTTP.post('/api/get-summary', {
      year: params.year,
    })
      .then(response => {
        if (response.status === 200) {
          context.commit('setSummaryData', {data: response.data, year: params.year})
          context.commit('setPreloaderState', false)
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setPreloaderState', false)
      //await this.dispatch('summary/getReportMonths')

  },
  getReportMonths(context, params = {}) {
    let access = context.rootGetters.chechAccess('summary')
    if (!access) {
      context.commit('setReportPreloaderState', false)
      return false
    }
    let defaultParams = {
      dateFrom: moment({ year: state.year }).format('YYYY-MM-DD'),
      dateTo: moment({ year: state.year })
        .endOf('year')
        .format('YYYY-MM-DD'),
    }
    params = { ...defaultParams, ...params }

    context.commit('setReportPreloaderState', true)
    HTTP.post('/api/get-report-months', params)
      .then(response => {
        if (response.status === 200) context.commit('setReportMonths', response.data)
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setReportPreloaderState', false)
  },
  async getReportFile(context, params = {}) {
    let access = context.rootGetters.chechAccess('summary')
    if (!access) {
      context.commit('setReportPreloaderState', false)
      return false
    }
    params.type = params.type || 'docx'
    let defaultParams = {
      dateFrom: moment({ year: state.year }).format('YYYY-MM-DD'),
      dateTo: moment({ year: state.year })
        .endOf('year')
        .format('YYYY-MM-DD'),
    }
    params = { ...defaultParams, ...params }

    let url = params.type === 'docx' ? '/api/make-report' : '/api/make-xls-report'

    context.commit('setReportPreloaderState', true)
    await HTTP.post(url, params, {
      responseType: 'arraybuffer',
    })
      .then(response => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'report.' + params.type) // or any other extension
          document.body.appendChild(link)
          link.click()
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setReportPreloaderState', false)
  },
  getReportPreview(context, params = {}) {
    return new Promise((resolve, reject) => {
      let access = context.rootGetters.chechAccess('summary')
      if (!access) {
        context.commit('setReportPreloaderState', false)
        return false
      }
      let defaultParams = {
        dateFrom: moment({ year: state.year }).format('YYYY-MM-DD'),
        dateTo: moment({ year: state.year })
          .endOf('year')
          .format('YYYY-MM-DD'),
      }
      params = { ...defaultParams, ...params }
      context.commit('setReportPreloaderState', true)
      HTTP.post('/api/report-preview', params)
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(e => {
          this.errorMessage = e
          this.dispatch('errorProcess', e)
          reject(e)
        })
      context.commit('setReportPreloaderState', false)
    })
  },
  getReportFilters() {
    return new Promise((resolve, reject) => {
      HTTP.post('/api/get-filters')
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(e => {
          this.errorMessage = e
          this.dispatch('errorProcess', e)
          reject(e)
        })
    })
  },
}
// getters
const getters = {
  getSummary(state) {
    return state.summaryData
  },
  getReportMonths(state) {
    return state.reportMonths
  },
  getPreloader(state) {
    return state.preloader
  },
  getReportPreloader(state) {
    return state.reportPreloader
  },
  getYear(state) {
    return state.year
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
